module.exports = __webpack_public_path__ + "static/media/logoVideo.c4a11961.mp4";